import React from 'react';
import ATable from '../../common/table';
import { permissioned } from '../../common/permissionedHoc';

const NewClaimTxnTable = (props) => {

    //Column Definition
    const columns = [{
        header: "S/N",
        width: 50,
        render :  row => (<div>{row.viewIndex + 1}</div>)
    }, 
    {
        header: "Issuer",
        accessor: "issuer"
    },
    {
        header: "Acquirer",
        accessor: "acquirer"
    },
    {
        header: "Customer Ref.",
        accessor: "customerReference",
        width: 130,
    },
    {
        header: "Terminal ID",
        accessor: "terminalId"
    },
    
     {
        header: "STAN",
        accessor: "stan",
        width: 100
    },
    
    
    {
        header: "Tran. Date",
        accessor: "transactionDate"
    },
    {
        header: "Tran. Type",
        accessor: "transactionType"
    },
    {
        header: "Tran. Amount",
        accessor: "transactionAmount",
        width: 160,
        render :  row => { return `${row.row.transactionAmount}`},

    }
    

    ];
    return (
            <ATable
                className="-striped -highlight"
                tableData={props.tableData}
                columns={columns}
                loading={props.loading}
                onRowClick={props.onRowClick} 
                />
    )
};

export default permissioned(NewClaimTxnTable);


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/newClaim/newClaimTxnTable.js